import axios from 'axios';

const baseURL = (() => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  try {
    const { host } = window.location;
    if (host.includes('localhost') || host.includes('127.0.0.1')) {
      return 'http://localhost:5000';
    }
    return '/api';
  } catch {
    return '/api';
  }
})();

export const api = axios.create({
  baseURL,
  timeout: 60000,
  withCredentials: true,
});

export const publicSaasSignupService = {
  signup: (body: Record<string, unknown>) => api.post('/public/saas/signup', body),
  signupStatus: (token: string) =>
    api.get('/public/saas/signup-status', { params: { token } }),
  checkSignupAvailability: (tenant_key: string, email: string) =>
    api.get('/public/saas/check-signup-availability', {
      params: { tenant_key, email },
    }),
};
